import React, { useState } from "react";
import { GraduationCap } from "lucide-react";
import TutorialModal from "./TutorialModal";

const TutorialButton = ({ section, label, sidebarOpen, variant, sector = "general", accentColor = "red", compact = false, iconOnly = false }) => {
  const [open, setOpen] = useState(false);
  const isSidebarMode = sidebarOpen !== undefined;
  const isBlue = accentColor === "blue";
  const isGhost = variant === "pill-ghost";

  return (
    <>
      {iconOnly ? (
        <button
          onClick={() => setOpen(true)}
          title={`Video tutorial: ${label}`}
          aria-label={`Video tutorial: ${label}`}
          className={`shrink-0 p-1.5 rounded-lg border transition-all active:scale-95 ${isBlue ? "border-blue-200 bg-blue-50 text-blue-600 hover:bg-blue-100" : "border-red-200 bg-red-50 text-red-600 hover:bg-red-100"}`}
        >
          <GraduationCap size={14} />
        </button>
      ) : isSidebarMode ? (
        <button
          onClick={() => setOpen(true)}
          title="¿Qué es ConextCRM?"
          aria-label="¿Qué es ConextCRM?"
          className={[
            `flex items-center gap-2 w-full px-3 py-2 rounded-lg text-sm font-medium border border-transparent transition-colors text-gray-500 dark:text-gray-400 hover:bg-[var(--sidebar-hover-bg)] ${isBlue ? "hover:text-blue-600" : "hover:text-red-600"} hover:border-[var(--sidebar-border)]`,
            !sidebarOpen ? "justify-center px-0" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <GraduationCap size={18} className="shrink-0" />
          {sidebarOpen && <span>{label}</span>}
        </button>
      ) : (
        <button
          onClick={() => setOpen(true)}
          title={`Tutorial: ${label}`}
          aria-label={`Tutorial: ${label}`}
          className={[
            "flex items-center rounded-xl border font-semibold transition-all active:scale-95",
            compact ? "gap-1 px-2 py-0.5 text-[11px]" : "gap-1.5 px-3 py-1.5 text-xs",
            isGhost
              ? "border-white/30 bg-white/15 text-white hover:bg-white/25 hover:border-white/50"
              : isBlue
                ? "border-blue-200 bg-blue-50 text-blue-600 hover:bg-blue-100"
                : "border-red-200 bg-red-50 text-red-600 hover:bg-red-100",
          ].join(" ")}
        >
          <GraduationCap size={compact ? 12 : 14} />
          <span>Video tutorial</span>
        </button>
      )}
      <TutorialModal
        open={open}
        onClose={() => setOpen(false)}
        section={section}
        label={label}
        sector={sector}
        accentColor={accentColor}
      />
    </>
  );
};

export default TutorialButton;
